import { lazy } from "react"

export const FuelById = lazy(() => import("./FuelById"))
